<template>
    <section class="book-container" @click="ShowRoute">
        <div class="book" :style="bookStyles">
            <img :src="frontCover" :alt="title"/>
            <!-- Tranche des pages -->
            <div class="pages-edge"></div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'
import {route} from "@/helper.js";

// Props du composant
const props = defineProps({
    id:{
        type:Number
    },
    frontCover: {
        type: String,
        required: true,
        default: '/images/book.jpg'
    },
    backCover: {
        type: String,
        default: '/images/book.jpg'
    },
    spine: {
        type: String,
        default: '/images/book.jpg'
    },
    title: {
        type: String,
        default: 'Livre'
    },
    slug:{
        type: String,
        default: '',
    },
    width: {
        type: Number,
        default: 277
    },
    height: {
        type: Number,
        default: 370
    },
    spineWidth: {
        type: Number,
        default: 45
    },
    pageColor: {
        type: String,
        default: '#fffff'
    }
})

const ShowRoute=()=>{
    window.location.href=route('show-book',{book:props.id,slug:props.slug})
}

// Styles calculés pour le livre
const bookStyles = computed(() => ({
    '--front-cover': `url(${props.frontCover})`,
    '--back-cover': `url(${props.backCover})`,
    '--spine-image': `url(${props.spine})`,
    '--book-width': `${props.width}px`,
    '--book-height': `${props.height}px`,
    '--spine-width': `${props.spineWidth}px`,
    '--page-color': props.pageColor
}))
</script>

<style scoped>
.book-container {
    display: flex;
    justify-content: center;
    align-items: center;
    transform-style: preserve-3d;
    perspective: 1000px;
    padding: 0.25rem;
    margin-bottom: 50px;
}

.book {
    position: relative;
    width: var(--book-width);
    height: var(--book-height);
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.2);
    transform-style: preserve-3d;
    transform: rotateY(18deg);
    transition: 0.5s;
    cursor: pointer;
}

/* Dos du livre (spine) - côté gauche */
.book::before {
    content: '';
    position: absolute;
    width: var(--spine-width);
    height: 100%;
    left: 0;
    top: 0;
    transform-origin: left;
    background: var(--spine-image);
    background-size: cover;
    background-position: center;
    transform: rotateY(90deg);
}

/* Couverture arrière */
.book::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: var(--back-cover);
    background-size: cover;
    background-position: center;
    transform: rotateY(180deg) translateZ(var(--spine-width));
}

/* Tranche des pages - côté droit */
.pages-edge {
    position: absolute;
    width: var(--spine-width);
    height: 100%;
    right: 0;
    top: 0;
    transform-origin: right;
    transform: rotateY(-90deg);
    background: linear-gradient(
        to left,
        var(--page-color) 0%,
        #f3f1ea 25%,
        #e9e6de 50%,
        #f3f1ea 75%,
        var(--page-color) 100%
    );
    background-image:
        repeating-linear-gradient(
            0deg,
            transparent,
            transparent 2px,
            rgba(0,0,0,0.05) 2px,
            rgba(0,0,0,0.05) 3px
        );
    border-left: 1px solid #dcdcdc;
    box-shadow:
        inset 4px 0 6px rgba(0, 0, 0, 0.15),
        inset -2px 0 4px rgba(255, 255, 255, 0.6);
}
.book:hover {
    transform: rotateY(35deg);
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.2);
}

.book:active {
    transform: rotateY(180deg);
}

/* Couverture avant */
.book img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 2px;
    z-index: 1;
}
</style>
